module.exports = __webpack_public_path__ + "static/media/18_tn.c4834fde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/18_tn.jpg
// module id = 448
// module chunks = 0